import React from 'react';
import '../App.css'
import { AiOutlineClose } from 'react-icons/ai';
import { HomeDataContext } from "../contexts/HomeDataContext";
import { homeDataService } from "../services/HomeDataService";
import { userService } from '../services/UserService';
import { deleteLocalStorage, authHeader, gettokens, getDidTokens } from "../helpers/auth-header";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { InformationCircleIcon, ClipboardDocumentIcon, ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline'
import { Fragment, useState } from 'react'
import SideMenu from './SideMenu';

import Axios from "axios";

import {
	Bars3Icon,
	XMarkIcon
} from '@heroicons/react/24/outline'
var url = process.env.REACT_APP_URL || "http://localhost:8080/";

const firebaseConfig = {
	apiKey: "AIzaSyCT-HKuQUQT94cSIF5Fu7zzPnWbn9ao8i0",
	authDomain: "hopguides.firebaseapp.com",
	projectId: "hopguides",
	storageBucket: "hopguides.appspot.com",
	messagingSenderId: "520191148823",
	appId: "1:520191148823:web:f1920e502d3f692840ad52"
};

firebase.initializeApp(firebaseConfig);
function classNames(...classes) {
	return classes.filter(Boolean).join(' ')
}

function Library() {
	// Moved state to this parent component


	const products = [
		{
			url: "https://hopguides.s3.eu-central-1.amazonaws.com/library/1698141311719-231.mp4",
			qrcode: "https://hopguides.s3.eu-central-1.amazonaws.com/library/1698141314147-356.png",
			userId: "7e378942-dd92-4066-82b7-0f8d7b8cce69"
		}, {
			url: "https://hopguides.s3.eu-central-1.amazonaws.com/library/1698141311719-231.mp4",
			qrcode: "https://hopguides.s3.eu-central-1.amazonaws.com/library/1698141314147-356.png",
			userId: "7e378942-dd92-4066-82b7-0f8d7b8cce69"
		},

		// More products...
	]

	const [copied, setCopied] = useState(false);
	const [copiedId, setCopiedId] = useState(null);
	const [errorMessage, setErrorMessage] = React.useState("");
	const [countTokens, setCountTokens] = React.useState(false);
	const [tokens, setTokens] = React.useState("");
	const [selectedImage, setSelectedImage] = React.useState('imgSam');
	const [updateapi, setUpdateapi] = React.useState(false);
	const [api, setApi] = React.useState("");
	const [videos, setVideos] = React.useState([]);
	const [sidebarOpen, setSidebarOpen] = useState(false)

	const [isOpen, setIsOpen] = useState(false)
	const [isLoaded, setIsLoaded] = React.useState(false); // New state to track loading
	const [admin, setAdmin] = React.useState(false);


	const { homeDataState, dispatch } = React.useContext(HomeDataContext);

	const handleCopyClick = async (e, productId, url) => {
		e.preventDefault();
		try {
			await navigator.clipboard.writeText(url);
			setCopiedId(productId);
			setTimeout(() => setCopiedId(null), 3000); // Reset after 3 seconds
		} catch (err) {
			console.error('Failed to copy text: ', err);
		}
	};



	React.useEffect(() => {


		// Using an async function inside useEffect
		const fetchData = async () => {
			var tokens = await userService.getTokens(dispatch);
			var videos = await homeDataService.getVideosForLibrary(dispatch);
			var token = authHeader();

			if (token == "null" || tokens == "undefined" || tokens == "null") {
				window.location = "#/login";
			} else {
				setIsLoaded(true); // Set isLoaded to true only if tokens are valid



			};


			Axios.get(`${url}api/users/getRole`, { headers: { Authorization: token } }, { validateStatus: () => true },
			)
				.then((res) => {
					if (res.status === 200) {

						if ("ADMIN" == res.data) {
							setAdmin(true)
						}
						else {
							setAdmin(false)
						}
					}
				})
				.catch((err) => {
				})



		};





		fetchData(); // Call the async function

	}, []); // Empty depe


	const handleLogout = () => {
		deleteLocalStorage();
		firebase.auth().signOut().then(function () {
			// Sign-out successful.
		}).catch(function (error) {
			// An error happened.
		});
		window.location = "#/login";
	};
	const toggleMenu = () => {
		setIsOpen(!isOpen);
	};


	return (



		<div className="min-h-screen flex felx-row items-start md:items-stretch md:overflow-hidden divide-x-0 md:divide-x relative">

			<div className="hidden lg:flex">
				<SideMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} admin={admin} setUpdateapi={setUpdateapi} handleLogout={handleLogout} library={true} />
			</div>

			<main className="min-h-screen flex flex-col gap-0 items-stretch w-full overflow-hidden lg:divide-y-0">

				{/* Mobile Nav */}
				<div className="flex flex-row items-center justify-between px-5 h-16 lg:hidden fixed z-40 left-0 top-0 right-0 bg-white border-b border-black/10">
					<div>
						<img className="h-8 w-auto" src="assets/img/logo.svg" alt="Your Company" />
					</div>
					<div>
						<button onClick={toggleMenu} className='w-6'>  <Bars3Icon /> </button>
					</div>
				</div>
				{isOpen && (

					<div className="fixed inset-0 z-50 bg-neutral-100/70 backdrop-blur lg:hidden">
						<div className="fixed top-3 right-3 z-50 bg-white rounded-2xl shadow">
							<div className="px-5 pt-5 pb-0 flex flex-row items-center justify-end">
								<button onClick={toggleMenu} className='w-6'><XMarkIcon /></button>
							</div>
							<div>
								<SideMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} admin={admin} setUpdateapi={setUpdateapi} handleLogout={handleLogout} library={true} />
							</div>
						</div>
					</div>
				)}
				{/* Right */}
				<div className="grow flex flex-col md:flex-row items-stretch w-full md:overflow-hidden divide-x-0 md:divide-x divide-y md:divide-y-0">

					<div className="grow flex flex-col items-stretch md:h-screen md:overflow-hidden">

						<div className="grow h-[70vh] md:h-full bg-neutral-100 pt-16 lg:pt-0 overflow-y-scroll">

							<div className="grid-menu grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2 p-5 pb-20">

								{homeDataState.videos.map((product) => (

									// Item
									<div key={product.id} className="grid-menu-item shadow-md !rounded-2xl"> {/* Added 'relative' */}

										<div className="flex flex-row items-stretch justify-stretch gap-2 p-2">
											{/* Video */}
											<div className="w-[40%] h-auto aspect-[3/4] rounded-xl overflow-hidden relative z-10 shrink-0">

												<video controls className="w-full h-full object-cover">
													<source src={product.url} type="video/mp4" />
													Your browser does not support the video tag.
												</video>

											</div>

											<div className="flex flex-col items-center justify-stretch gap-2 grow p-3">

												<div className="shrink-0 text-xs text-black/60">
													12. Aug., 2023
												</div>

												<div className="flex flex-col items-center justify-center grow">
													{/* QR */}
													<img
														src={product.qrcode}
														alt="Qr code"
														className="h-full max-h-28 w-auto aspec-[1/1] rounded-md border border-black/20 shadow-sm"
													/>
												</div>

												{/* Content */}
												<a key={product.id} href={product.url}
													onClick={(e) => handleCopyClick(e, product.id, product.url)}
													className="button button--primary button--small shrink-0">
													Copy link
													{copiedId === product.id
														? <ClipboardDocumentCheckIcon className="h-5 w-5" />
														: <ClipboardDocumentIcon className="h-5 w-5" />}
												</a>

											</div>

										</div>

									</div>

								))}

							</div>
						</div>
					</div>
				</div>
			</main>
		</div>

	);
}

export default Library;